/* eslint-disable prettier/prettier */
export enum TypeClass {
  candidate = 'CANDIDATE',
  company = 'COMPANY',
  user = 'USER',
}
